import { isArray, isObject } from 'lodash';

/**
 * @description 这个filter用来统一处理图虫的imageUrl
 * @param {*} options 选项数组 like: [image, webpEnabled, ...extraOption]
 *                    或者是CSS property object like: { backgroundImage: [image, webpEnabled, 'g'] }
 * @example <img :src=" [image, webpEnabled] | imageUrl ">
 */
function imageUrl(options) {
    if (isArray(options)) {
        return `//photo.tuchong.com/${options[0].user_id}/${options[2] || 'l'}/${options[0].img_id}.${options[1] ? 'webp' : 'jpg'}`;
    }
    if (isObject(options) && options.backgroundImage) {
        options.backgroundImage = `url(//photo.tuchong.com/${options.backgroundImage[0].user_id}/${options.backgroundImage[2] || 'l'}/${options.backgroundImage[0].img_id}.${options.backgroundImage[1] ? 'webp' : 'jpg'})`;
        return options;
    }
    throw new Error('imageUrl filter参数必须为数组或者CSS property object');
}

export default imageUrl;
